<div class="overlay"></div>
<div *ngIf="!otpSuccess" class="modal-otp" (click)="$event.stopPropagation()">
    <div class="modal-header">
        <img
            src="../../../assets/login/logo.png"
            alt="Datacore Logo"
            class="logo"
        />
    </div>

    <div class="modal-body">
        <img
            (click)="goBack()"
            src="../../../assets/login/arrow-left.png"
            alt="back"
            class="back"
        />
        <h2>{{ 'otp.title' | translate }}</h2>
        <p>
            {{ 'otp.description' | translate }}
            <br />
            {{ email }}
        </p>

        <div class="otp-inputs">
            <input
                *ngFor="let box of otpBoxes; let i = index"
                type="text"
                maxlength="1"
                [(ngModel)]="otp[i]"
                (input)="onInput($event, i)"
                (keydown.backspace)="onBackspace($event, i)"
            />
        </div>

        <button
            class="btn-otp-primary"
            [class.active]="active"
            (click)="verifyOtp()"
        >
            {{ 'otp.continue' | translate }}
        </button>

        <div class="resend-section">
            <a *ngIf="canResend" (click)="resendEmail()">{{ 'otp.resend.action' | translate }}</a>
            <p *ngIf="!canResend">
                {{ 'otp.resend.action' | translate }}<br /><span>{{ timer | date : "mm:ss" }}</span>
            </p>
        </div>
    </div>
</div>
<ng-container *ngIf="otpSuccess">
    <div class="popup-overlay">
        <div class="popup-box">
            <div class="popup-header">
                <img src="../../../assets/login/logo.png"
                    alt="Datacore Logo"
                    class="logo" />
            </div>

            <div class="icon-success">
                <img src="../../../assets//login/success.png" />
            </div>

            <h2>{{ 'registerSuccess.title' | translate }}</h2>

            <p>
                {{ 'registerSuccess.descriptionLine1' | translate }}<br />
                {{ 'registerSuccess.descriptionLine2' | translate }}
            </p>

            <button (click)="login()" class="btn-login">{{ 'registerSuccess.login' | translate }}</button>
        </div>
    </div>
</ng-container>
